import { useEffect, useMemo, useState } from 'react';
import { getActiveOffers, getOfferCategories } from '../services/offersService';

/**
 * @param {string|null|undefined} userTier
 * @param {{ country?: string|null, communityId?: string|null }} [audience] Profile fields for targeting; pass from `user` on Rewards.
 */
export function useOffers(userTier, audience) {
  const country = audience?.country ?? null;
  const communityId = audience?.communityId ?? null;

  const [offers, setOffers] = useState([]);
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setStatus('loading');
      setErrorMessage('');
      try {
        const rows = await getActiveOffers({ country, communityId });
        if (cancelled) return;
        setOffers(rows);
        setStatus('success');
      } catch (e) {
        if (cancelled) return;
        setOffers([]);
        setStatus('error');
        setErrorMessage(e?.message || 'Failed to load offers');
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [userTier, country, communityId]);

  const categories = useMemo(() => getOfferCategories(offers), [offers]);

  return { offers, categories, status, errorMessage };
}

